export default {
  root: {
    padding: 40,
  },
  formContainer: {
    padding: 40,
  },
  innerContainer: {
    padding: 20,
  },
  buttonsBox: {
    paddingTop: 20,
  },
  buttonSave: {
    marginLeft: 20,
    width: 125,
  },
  buttonCancel: {
    width: 125,
  },
  busyBackdrop: {
    zIndex: 2000,
  },
  dialogRoot: {
    padding: 40,
  },
  thumbnail: {
    width: '100%',
    height: '100%',
  },
  actionCardContainer: {
    backgroundColor: 'lightGrey',
    padding: 0,
    borderRadius: 5,
  },
  actionCardHeader: {
    width: '100%',
    borderRadius: 5,
    backgroundColor: 'grey',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    paddingBottom: 5,
  },
  actionCardHeaderDragIcon: {
    height: '100%',
    margin: 5,
  },
  actionCardContent: {
    display: 'flex',
    marginLeft: 10,
    marginRight: 10,
    marginTop: 10,
    marginBottom: 10,
  },
  actionCardThumbnail: {
    height: 100,
  },
  actionCardDetails: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: 10,
  },
  actionDropTargetIndicator: {
    height: 40,
    marginTop: 10,
    marginBottom: 10,
  },
}
